import createSvgIcon from '@mui/material/utils/createSvgIcon';

const Skipped = createSvgIcon(
  <svg
    viewBox="0 0 25 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 12C23 17.799 18.299 22.5 12.5 22.5C6.70101 22.5 2 17.799 2 12C2 6.20101 6.70101 1.5 12.5 1.5C18.299 1.5 23 6.20101 23 12ZM24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.5 18.6274 0.5 12C0.5 5.37258 5.87258 0 12.5 0C19.1274 0 24.5 5.37258 24.5 12ZM11.8152 9.68426C13.6285 9.68426 15.2708 10.3617 16.5367 11.4633L19 9V15.1584H12.8416L15.3187 12.6813C14.3675 11.8876 13.1496 11.3949 11.8152 11.3949C9.38612 11.3949 7.33333 12.9756 6.61486 15.1584L5 14.6246C5.94428 11.7576 8.63343 9.68426 11.8152 9.68426Z"
      />
    </g>
    <defs>
      <clipPath
        id="clip0">
        <rect
          width="24"
          height="24"
          transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>,
  'Skipped'
)

export default Skipped;
